import { Injectable } from '@angular/core';
import * as Excel from "exceljs/dist/exceljs.min.js";
import * as FileSaver from 'file-saver';
import { DefaultService, ApuInspectionReport} from "@psnb/psnb-api";

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelApuInspectionReportService {
  searchHieArray: any;

  constructor(private powerSupplyService: DefaultService) { }

  public getApuInspectionReports(nodeId, regionName) {
    this.searchHieArray =  JSON.parse(JSON.stringify('{"nodeId":'+'['+nodeId+']'+',"regionName":"'+regionName+'"}'));
    return this.powerSupplyService.getAPUInspectionReports(this.searchHieArray);
  }

  public exportApuInspectionReportAsExcelFile(json: ApuInspectionReport[], excelFileName: string, fileType: string) {
    let min = 0;
    let max = 40000;
    let numberOfSheets = 0;
    if (json.length >= 40000) {
      if (json.length % 40000 === 0) numberOfSheets = json.length / 40000;
      else numberOfSheets = json.length / 40000 + 1;
    } else {
      numberOfSheets = 1;
      max = json.length;
    }
    const workbook = new Excel.Workbook;
    for (let i = 1; i <= numberOfSheets; i++) {
      workbook.addWorksheet('APUINSPECTION' + i);
      const sheet = workbook.getWorksheet(i);
      sheet.columns = this.getHeaders(fileType, json.slice(min, max));
      sheet.addRows(json.slice(min, max));
      if (fileType === 'APUINSPECTION') {
        sheet.eachRow(function (row, rowNumber) {
          row.eachCell({ includeEmpty: true }, function (cell) {
            if (rowNumber === 1) {
              sheet.getCell(cell.address.toString()).fill = {
                type: 'gradient', gradient: 'angle', degree: 0, stops: [
                  { position: 0, color: { argb: 'd9f1fa' } },
                  { position: 0.5, color: { argb: 'd9f1fa' } },
                  { position: 1, color: { argb: 'd9f1fa' } }
                ]
              };
              sheet.getCell(cell.address.toString()).alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
              sheet.getCell(cell.address.toString()).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } };
              sheet.getCell(cell.address.toString()).font = { name: 'Calibri', family: 2, size: 8, bold: 'true' };
            } else {
              sheet.getCell(cell.address.toString()).alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
              sheet.getCell(cell.address.toString()).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } };
              sheet.getCell(cell.address.toString()).font = { name: 'Calibri', family: 2, size: 8 };
            }
          });
        });
      }
      if (max + 40000 <= json.length) {
        min = max;
        max = max + 40000;
      } else {
        min = max;
        max = max + (json.length - max);
      }
    }
    workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], { type: EXCEL_TYPE });
      FileSaver.saveAs(blob, excelFileName + EXCEL_EXTENSION);
    })
    return false;
  }

  getHeaders(fileType: string, json: any) {
    if (fileType === 'APUINSPECTION') {
      let wchPowerSupplyId = 14;
      let wchRegionName = 11;
      let wchHeadendName = 12;
      let wchCommunityName = 14;
      let wchName = 5;
      let wchPowerSupplyName = 20;
      let wchIp = 3;
      let wchMacAddress = 11;
      let wchHouseNumber = 12;
      let wchPowerSupplyAddress = 19;
      let wchCrossStreet = 12;
      let wchCity = 5;
      let wchState = 6;
      let wchZip = 4;
      let wchNode2 = 6;
      let wchNode3 = 6;
      let wchNode4 = 6;
      let wchNode5 = 6;
      let wchNode6 = 6;
      let wchNode7 = 6;
      let wchNode8 = 6;
      let wchNode9 = 6;
      let wchNode10 = 7;
      let wchNode11 = 7;
      let wchNode12 = 7;
      let wchNode13 = 7;
      let wchNode14 = 7;
      let wchNode15 = 7;
      let wchInspectionDate = 15;
      let wchApuBatteryManufacturerType = 26;
      let wchApuBatteryDateCode = 18;
      let wchApuBatteryInstallDate = 21;
      let wchApuBatteryVoltageNoLoad = 23;
      let wchApuBatteryConductance = 21;
      let wchApuBatteryConductanceCorrected = 30;
      let wchApuBatteryTorque = 16;
      let wchApuBatteryTerminalsCleaned = 26;
      let wchApuStarterBatteryChargerVoltage = 31;
      let wchApuChargerCurrentAmps = 21;
      let wchFollowUpActionNeeded = 20;
      let wchRecordAsFoundAlarms = 19;
      let wchApuVisitComments = 16;
      let wchApuCompletedBy = 14;
      let wchApuTestRun = 10;
      let wchCheckOilLevel = 13;
      let wchOilAddedAmount = 14;
      let wchOilFilterTight = 14;
      let wchInspectGeneratorAirFilter = 25;
      let wchInspectSparkPlug = 16;
      let wchClearApuEventLog = 16;
      let wchApuFrequency = 12;
      let wchTankOneLevel = 12;
      let wchTankTwoLevel = 12;
      let wchGasMeterNumber = 14;
      let wchGasMeterReading = 15;
      let wchNgPressure = 10;
      let wchChangeCleanEnclosureAirFilter = 29;
      let wchCheckForRodentDamage = 20;
      let wchCheckLampsLed = 13;
      let wchClearWeeds = 10;
      let wchCheckRegroutPadConduit = 22;
      let wchGroundMountPadUndermining = 25;
      let wchEnclosureDamageVandalism = 24;
      let wchCleanUpGarbage = 14;
      let wchTestOilPressureAlarm = 20;
      let wchTestHighTempAlarm = 17;
      let wchGeneratorDcBusFunction = 22;
      let wchCheckForGasLeaks = 16;
      let wchTestCombustibleGasAlarm = 23;
      let wchTestTamperAlarm = 15;
      let wchTestWaterIntrusionAlarm = 23;
      let wchTestPadShearAlarm = 17;
      json.forEach(jsonTestPsApuReports => {
        if (jsonTestPsApuReports.powerSupplyId !== null && wchPowerSupplyId <= jsonTestPsApuReports.powerSupplyId.toString.length) {
          wchPowerSupplyId = jsonTestPsApuReports.powerSupplyId.toString.length;
        }
        if (jsonTestPsApuReports.regionName !== null && wchRegionName <= jsonTestPsApuReports.regionName.length) {
          wchRegionName = jsonTestPsApuReports.regionName.length;
        }
        if (jsonTestPsApuReports.headendName !== null && wchHeadendName <= jsonTestPsApuReports.headendName.length) {
          wchHeadendName = jsonTestPsApuReports.headendName.length;
        }
        if (jsonTestPsApuReports.communityName !== null && wchCommunityName <= jsonTestPsApuReports.communityName.length) {
          wchCommunityName = jsonTestPsApuReports.communityName.length;
        }
        if (jsonTestPsApuReports.name !== null && wchName <= jsonTestPsApuReports.name.length) {
          wchName = jsonTestPsApuReports.name.length;
        }
        if (jsonTestPsApuReports.ip !== null && wchIp <= jsonTestPsApuReports.ip.length) {
          wchIp = jsonTestPsApuReports.ip.length;
        }
        if (jsonTestPsApuReports.macAddress !== null && wchMacAddress <= jsonTestPsApuReports.macAddress.length) {
          wchMacAddress = jsonTestPsApuReports.macAddress.length;
        }
        if (jsonTestPsApuReports.houseNumber !== null && wchHouseNumber <= jsonTestPsApuReports.houseNumber.length) {
          wchHouseNumber = jsonTestPsApuReports.houseNumber.length;
        }
        if (jsonTestPsApuReports.city !== null && wchCity <= jsonTestPsApuReports.city.length) {
          wchCity = jsonTestPsApuReports.city.length;
        }
        if (jsonTestPsApuReports.state !== null && wchState <= jsonTestPsApuReports.state.length) {
          wchState = jsonTestPsApuReports.state.length;
        }
        if (jsonTestPsApuReports.zip !== null && wchZip <= jsonTestPsApuReports.zip.length) {
          wchZip = jsonTestPsApuReports.zip.length;
        }
        if (jsonTestPsApuReports.node2 !== null && wchNode2 <= jsonTestPsApuReports.node2.length) {
          wchNode2 = jsonTestPsApuReports.node2.length;
        }
        if (jsonTestPsApuReports.node3 !== null && wchNode3 <= jsonTestPsApuReports.node3.length) {
          wchNode3 = jsonTestPsApuReports.node3.length;
        }
        if (jsonTestPsApuReports.node4 !== null && wchNode4 <= jsonTestPsApuReports.node4.length) {
          wchNode4 = jsonTestPsApuReports.node4.length;
        }
        if (jsonTestPsApuReports.node5 !== null && wchNode5 <= jsonTestPsApuReports.node5.length) {
          wchNode5 = jsonTestPsApuReports.node5.length;
        }
        if (jsonTestPsApuReports.node6 !== null && wchNode6 <= jsonTestPsApuReports.node6.length) {
          wchNode6 = jsonTestPsApuReports.node6.length;
        }
        if (jsonTestPsApuReports.node7 !== null && wchNode7 <= jsonTestPsApuReports.node7.length) {
          wchNode7 = jsonTestPsApuReports.node7.length;
        }
        if (jsonTestPsApuReports.node8 !== null && wchNode8 <= jsonTestPsApuReports.node8.length) {
          wchNode8 = jsonTestPsApuReports.node8.length;
        }
        if (jsonTestPsApuReports.node9 !== null && wchNode9 <= jsonTestPsApuReports.node9.length) {
          wchNode9 = jsonTestPsApuReports.node9.length;
        }
        if (jsonTestPsApuReports.node10 !== null && wchNode10 <= jsonTestPsApuReports.node10.length) {
          wchNode10 = jsonTestPsApuReports.node10.length;
        }
        if (jsonTestPsApuReports.node11 !== null && wchNode11 <= jsonTestPsApuReports.node11.length) {
           wchNode11 = jsonTestPsApuReports.node11.length;
         }
         if (jsonTestPsApuReports.node12 !== null && wchNode12 <= jsonTestPsApuReports.node12.length) {
           wchNode12 = jsonTestPsApuReports.node12.length;
         }
         if (jsonTestPsApuReports.node13 !== null && wchNode13 <= jsonTestPsApuReports.node13.length) {
           wchNode13 = jsonTestPsApuReports.node13.length;
         }
         if (jsonTestPsApuReports.node14 !== null && wchNode14 <= jsonTestPsApuReports.node14.length) {
           wchNode14 = jsonTestPsApuReports.node14.length;
         }
         if (jsonTestPsApuReports.node15 !== null && wchNode15 <= jsonTestPsApuReports.node15.length) {
           wchNode15 = jsonTestPsApuReports.node15.length;
         }
        if (jsonTestPsApuReports.inspectionDate !== null && wchInspectionDate <= jsonTestPsApuReports.inspectionDate.length) {
          wchInspectionDate = jsonTestPsApuReports.inspectionDate.length;
        }
        if (jsonTestPsApuReports.apuBatteryManufacturerType !== null && wchApuBatteryManufacturerType <= jsonTestPsApuReports.apuBatteryManufacturerType.length) {
          wchApuBatteryManufacturerType = jsonTestPsApuReports.apuBatteryManufacturerType.length;
        }
        if (jsonTestPsApuReports.apuBatteryDateCode !== null && wchApuBatteryDateCode <= jsonTestPsApuReports.apuBatteryDateCode.length) {
          wchApuBatteryDateCode = jsonTestPsApuReports.apuBatteryDateCode.length;
        }
        if (jsonTestPsApuReports.apuBatteryInstallDate !== null && wchApuBatteryInstallDate <= jsonTestPsApuReports.apuBatteryInstallDate.length) {
          wchApuBatteryInstallDate = jsonTestPsApuReports.apuBatteryInstallDate.length;
        }
        if (jsonTestPsApuReports.apuBatteryVoltageNoLoad !== null && wchApuBatteryVoltageNoLoad <= jsonTestPsApuReports.apuBatteryVoltageNoLoad.length) {
          wchApuBatteryVoltageNoLoad = jsonTestPsApuReports.apuBatteryVoltageNoLoad.length;
        }
        if (jsonTestPsApuReports.apuBatteryConductance !== null && wchApuBatteryConductance <= jsonTestPsApuReports.apuBatteryConductance.toString.length) {
          wchApuBatteryConductance = jsonTestPsApuReports.apuBatteryConductance.toString.length;
        }
        if (jsonTestPsApuReports.apuBatteryConductanceCorrected !== null && wchApuBatteryConductanceCorrected <= jsonTestPsApuReports.apuBatteryConductanceCorrected.length) {
          wchApuBatteryConductanceCorrected = jsonTestPsApuReports.apuBatteryConductanceCorrected.length;
        }
        if (jsonTestPsApuReports.apuBatteryTorque !== null && wchApuBatteryTorque <= jsonTestPsApuReports.apuBatteryTorque.toString.length) {
          wchApuBatteryTorque = jsonTestPsApuReports.apuBatteryTorque.toString.length;
        }
        if (jsonTestPsApuReports.apuBatteryTerminalsCleaned !== null && wchApuBatteryTerminalsCleaned <= jsonTestPsApuReports.apuBatteryTerminalsCleaned.length) {
          wchApuBatteryTerminalsCleaned = jsonTestPsApuReports.apuBatteryTerminalsCleaned.length;
        }
        if (jsonTestPsApuReports.apuStarterBatteryChargerVoltage !== null && wchApuStarterBatteryChargerVoltage <= jsonTestPsApuReports.apuStarterBatteryChargerVoltage.toString.length) {
          wchApuStarterBatteryChargerVoltage = jsonTestPsApuReports.apuStarterBatteryChargerVoltage.toString.length;
        }
        if (jsonTestPsApuReports.apuChargerCurrentAmps !== null && wchApuChargerCurrentAmps <= jsonTestPsApuReports.apuChargerCurrentAmps.toString.length) {
          wchApuChargerCurrentAmps = jsonTestPsApuReports.apuChargerCurrentAmps.toString.length;
        }
        if (jsonTestPsApuReports.followUpActionNeeded !== null && wchFollowUpActionNeeded <= jsonTestPsApuReports.followUpActionNeeded.length) {
          wchFollowUpActionNeeded = jsonTestPsApuReports.followUpActionNeeded.length;
        }
        if (jsonTestPsApuReports.recordAsFoundAlarms !== null && wchRecordAsFoundAlarms <= jsonTestPsApuReports.recordAsFoundAlarms.length) {
          wchRecordAsFoundAlarms = jsonTestPsApuReports.recordAsFoundAlarms.length;
        }
        if (jsonTestPsApuReports.apuVisitComments !== null && wchApuVisitComments <= jsonTestPsApuReports.apuVisitComments.length) {
          wchApuVisitComments = jsonTestPsApuReports.apuVisitComments.length;
        }
        if (jsonTestPsApuReports.apuCompletedBy !== null && wchApuCompletedBy <= jsonTestPsApuReports.apuCompletedBy.length) {
          wchApuCompletedBy = jsonTestPsApuReports.apuCompletedBy.length;
        }
        if (jsonTestPsApuReports.apuTestRun !== null && wchApuTestRun <= jsonTestPsApuReports.apuTestRun.length) {
          wchApuTestRun = jsonTestPsApuReports.apuTestRun.length;
        }
        if (jsonTestPsApuReports.checkOilLevel !== null && wchCheckOilLevel <= jsonTestPsApuReports.checkOilLevel.length) {
          wchCheckOilLevel = jsonTestPsApuReports.checkOilLevel.length;
        }
        if (jsonTestPsApuReports.oilAddedAmount !== null && wchOilAddedAmount <= jsonTestPsApuReports.oilAddedAmount.length) {
          wchOilAddedAmount = jsonTestPsApuReports.oilAddedAmount.length;
        }
        if (jsonTestPsApuReports.oilFilterTight !== null && wchOilFilterTight <= jsonTestPsApuReports.oilFilterTight.length) {
          wchOilFilterTight = jsonTestPsApuReports.oilFilterTight.length;
        }
        if (jsonTestPsApuReports.inspectGeneratorAirFilter !== null && wchInspectGeneratorAirFilter <= jsonTestPsApuReports.inspectGeneratorAirFilter.length) {
          wchInspectGeneratorAirFilter = jsonTestPsApuReports.inspectGeneratorAirFilter.length;
        }
        if (jsonTestPsApuReports.inspectSparkPlug !== null && wchInspectSparkPlug <= jsonTestPsApuReports.inspectSparkPlug.length) {
          wchInspectSparkPlug = jsonTestPsApuReports.inspectSparkPlug.length;
        }
        if (jsonTestPsApuReports.clearApuEventLog !== null && wchClearApuEventLog <= jsonTestPsApuReports.clearApuEventLog.length) {
          wchClearApuEventLog = jsonTestPsApuReports.clearApuEventLog.length;
        }
        if (jsonTestPsApuReports.apuFrequency !== null && wchApuFrequency <= jsonTestPsApuReports.apuFrequency.length) {
          wchApuFrequency = jsonTestPsApuReports.apuFrequency.length;
        }
        if (jsonTestPsApuReports.tankOneLevel !== null && wchTankOneLevel <= jsonTestPsApuReports.tankOneLevel.length) {
          wchTankOneLevel = jsonTestPsApuReports.tankOneLevel.length;
        }
        if (jsonTestPsApuReports.tankTwoLevel !== null && wchTankTwoLevel <= jsonTestPsApuReports.tankTwoLevel.length) {
          wchTankTwoLevel = jsonTestPsApuReports.tankTwoLevel.length;
        }
        if (jsonTestPsApuReports.gasMeterNumber !== null && wchGasMeterNumber <= jsonTestPsApuReports.gasMeterNumber.length) {
          wchGasMeterNumber = jsonTestPsApuReports.gasMeterNumber.length;
        }
        if (jsonTestPsApuReports.gasMeterReading !== null && wchGasMeterReading <= jsonTestPsApuReports.gasMeterReading.length) {
          wchGasMeterReading = jsonTestPsApuReports.gasMeterReading.length;
        }
        if (jsonTestPsApuReports.ngPressure !== null && wchNgPressure <= jsonTestPsApuReports.ngPressure.length) {
          wchNgPressure = jsonTestPsApuReports.ngPressure.length;
        }
        if (jsonTestPsApuReports.changeCleanEnclosureAirFilter !== null && wchChangeCleanEnclosureAirFilter <= jsonTestPsApuReports.changeCleanEnclosureAirFilter.length) {
          wchChangeCleanEnclosureAirFilter = jsonTestPsApuReports.changeCleanEnclosureAirFilter.length;
        }
        if (jsonTestPsApuReports.checkForRodentDamage !== null && wchCheckForRodentDamage <= jsonTestPsApuReports.checkForRodentDamage.length) {
          wchCheckForRodentDamage = jsonTestPsApuReports.checkForRodentDamage.length;
        }
        if (jsonTestPsApuReports.checkLampsLed !== null && wchCheckLampsLed <= jsonTestPsApuReports.checkLampsLed.length) {
          wchCheckLampsLed = jsonTestPsApuReports.checkLampsLed.length;
        }
        if (jsonTestPsApuReports.clearWeeds !== null && wchClearWeeds <= jsonTestPsApuReports.clearWeeds.length) {
          wchClearWeeds = jsonTestPsApuReports.clearWeeds.length;
        }
        if (jsonTestPsApuReports.checkRegroutPadConduit !== null && wchCheckRegroutPadConduit <= jsonTestPsApuReports.checkRegroutPadConduit.length) {
          wchCheckRegroutPadConduit = jsonTestPsApuReports.checkRegroutPadConduit.length;
        }
        if (jsonTestPsApuReports.groundMountPadUndermining !== null && wchGroundMountPadUndermining <= jsonTestPsApuReports.groundMountPadUndermining.length) {
          wchGroundMountPadUndermining = jsonTestPsApuReports.groundMountPadUndermining.length;
        }
        if (jsonTestPsApuReports.enclosureDamageVandalism !== null && wchEnclosureDamageVandalism <= jsonTestPsApuReports.enclosureDamageVandalism.length) {
          wchEnclosureDamageVandalism = jsonTestPsApuReports.enclosureDamageVandalism.length;
        }
        if (jsonTestPsApuReports.cleanUpGarbage !== null && wchCleanUpGarbage <= jsonTestPsApuReports.cleanUpGarbage.length) {
          wchCleanUpGarbage = jsonTestPsApuReports.cleanUpGarbage.length;
        }
        if (jsonTestPsApuReports.testOilPressureAlarm !== null && wchTestOilPressureAlarm <= jsonTestPsApuReports.testOilPressureAlarm.length) {
          wchTestOilPressureAlarm = jsonTestPsApuReports.testOilPressureAlarm.length;
        }
        if (jsonTestPsApuReports.testHighTempAlarm !== null && wchTestHighTempAlarm <= jsonTestPsApuReports.testHighTempAlarm.length) {
          wchTestHighTempAlarm = jsonTestPsApuReports.testHighTempAlarm.length;
        }
        if (jsonTestPsApuReports.generatorDcBusFunction !== null && wchGeneratorDcBusFunction <= jsonTestPsApuReports.generatorDcBusFunction.length) {
          wchGeneratorDcBusFunction = jsonTestPsApuReports.generatorDcBusFunction.length;
        }
        if (jsonTestPsApuReports.checkForGasLeaks !== null && wchCheckForGasLeaks <= jsonTestPsApuReports.checkForGasLeaks.length) {
          wchCheckForGasLeaks = jsonTestPsApuReports.checkForGasLeaks.length;
        }
        if (jsonTestPsApuReports.testCombustibleGasAlarm !== null && wchTestCombustibleGasAlarm <= jsonTestPsApuReports.testCombustibleGasAlarm.length) {
          wchTestCombustibleGasAlarm = jsonTestPsApuReports.testCombustibleGasAlarm.length;
        }
        if (jsonTestPsApuReports.testTamperAlarm !== null && wchTestTamperAlarm <= jsonTestPsApuReports.testTamperAlarm.length) {
          wchTestTamperAlarm = jsonTestPsApuReports.testTamperAlarm.length;
        }
        if (jsonTestPsApuReports.testWaterIntrusionAlarm !== null && wchTestWaterIntrusionAlarm <= jsonTestPsApuReports.testWaterIntrusionAlarm.length) {
          wchTestWaterIntrusionAlarm = jsonTestPsApuReports.testWaterIntrusionAlarm.length;
        }
        if (jsonTestPsApuReports.testPadShearAlarm !== null && wchTestPadShearAlarm <= jsonTestPsApuReports.testPadShearAlarm.length) {
          wchTestPadShearAlarm = jsonTestPsApuReports.testPadShearAlarm.length;
        }
      });
      return [
        { header: 'PowerSupplyId', key: 'powerSupplyId', width: wchPowerSupplyId },
        { header: 'RegionName', key: 'regionName', width: wchRegionName },
        { header: 'HeadendName', key: 'headendName', width: wchHeadendName },
        { header: 'CommunityName', key: 'communityName', width: wchCommunityName },
        { header: 'Name', key: 'name', width: wchName },
        { header: 'PowerSupplyName', key: 'powerSupplyName', width: wchPowerSupplyName },
        { header: 'IP', key: 'ip', width: wchIp },
        { header: 'MacAddress', key: 'macAddress', width: wchMacAddress },
        { header: 'HouseNumber', key: 'houseNumber', width: wchHouseNumber },
        { header: 'PowerSupplyAddress', key: 'powerSupplyAddress', width: wchPowerSupplyAddress },
        { header: 'CrossStreet', key: 'crossStreet', width: wchCrossStreet },
        { header: 'City', key: 'city', width: wchCity },
        { header: 'State', key: 'state', width: wchState },
        { header: 'Zip', key: 'zip', width: wchZip },
        { header: 'Node2', key: 'node2', width: wchNode2 },
        { header: 'Node3', key: 'node3', width: wchNode3 },
        { header: 'Node4', key: 'node4', width: wchNode4 },
        { header: 'Node5', key: 'node5', width: wchNode5 },
        { header: 'Node6', key: 'node6', width: wchNode6 },
        { header: 'Node7', key: 'node7', width: wchNode7 },
        { header: 'Node8', key: 'node8', width: wchNode8 },
        { header: 'Node9', key: 'node9', width: wchNode9 },
        { header: 'Node10', key: 'node10', width: wchNode10 },
        { header: 'Node11', key: 'node11', width: wchNode11 },
        { header: 'Node12', key: 'node12', width: wchNode12 },
        { header: 'Node13', key: 'node13', width: wchNode13 },
        { header: 'Node14', key: 'node14', width: wchNode14 },
        { header: 'Node15', key: 'node15', width: wchNode15 },
        { header: 'InspectionDate', key: 'inspectionDate', width: wchInspectionDate },
        { header: 'ApuBatteryManufacturerType', key: 'apuBatteryManufacturerType', width: wchApuBatteryManufacturerType },
        { header: 'ApuBatteryDateCode', key: 'apuBatteryDateCode', width: wchApuBatteryDateCode },
        { header: 'ApuBatteryInstallDate', key: 'apuBatteryInstallDate', width: wchApuBatteryInstallDate },
        { header: 'ApuBatteryVoltageNoLoad', key: 'apuBatteryVoltageNoLoad', width: wchApuBatteryVoltageNoLoad },
        { header: 'ApuBatteryConductance', key: 'apuBatteryConductance', width: wchApuBatteryConductance },
        { header: 'ApuBatteryConductanceCorrected', key: 'apuBatteryConductanceCorrected', width: wchApuBatteryConductanceCorrected },
        { header: 'ApuBatteryTorque', key: 'apuBatteryTorque', width: wchApuBatteryTorque },
        { header: 'ApuBatteryTerminalsCleaned', key: 'apuBatteryTerminalsCleaned', width: wchApuBatteryTerminalsCleaned },
        { header: 'ApuStarterBatteryChargerVoltage', key: 'apuStarterBatteryChargerVoltage', width: wchApuStarterBatteryChargerVoltage },
        { header: 'ApuChargerCurrentAmps', key: 'apuChargerCurrentAmps', width: wchApuChargerCurrentAmps },
        { header: 'FollowUpActionNeeded', key: 'followUpActionNeeded', width: wchFollowUpActionNeeded },
        { header: 'RecordAsFoundAlarms', key: 'recordAsFoundAlarms', width: wchRecordAsFoundAlarms },
        { header: 'ApuVisitComments', key: 'apuVisitComments', width: wchApuVisitComments },
        { header: 'ApuCompletedBy', key: 'apuCompletedBy', width: wchApuCompletedBy },
        { header: 'ApuTestRun', key: 'apuTestRun', width: wchApuTestRun },
        { header: 'CheckOilLevel', key: 'checkOilLevel', width: wchCheckOilLevel },
        { header: 'OilAddedAmount', key: 'oilAddedAmount', width: wchOilAddedAmount },
        { header: 'OilFilterTight', key: 'oilFilterTight', width: wchOilFilterTight },
        { header: 'InspectGeneratorAirFilter', key: 'inspectGeneratorAirFilter', width: wchInspectGeneratorAirFilter },
        { header: 'InspectSparkPlug', key: 'inspectSparkPlug', width: wchInspectSparkPlug },
        { header: 'ClearApuEventLog', key: 'clearApuEventLog', width: wchClearApuEventLog },
        { header: 'ApuFrequency', key: 'apuFrequency', width: wchApuFrequency },
        { header: 'TankOneLevel', key: 'tankOneLevel', width: wchTankOneLevel },
        { header: 'TankTwoLevel', key: 'tankTwoLevel', width: wchTankTwoLevel },
        { header: 'GasMeterNumber', key: 'gasMeterNumber', width: wchGasMeterNumber },
        { header: 'GasMeterReading', key: 'gasMeterReading', width: wchGasMeterReading },
        { header: 'NgPressure', key: 'ngPressure', width: wchNgPressure },
        { header: 'ChangeCleanEnclosureAirFilter', key: 'changeCleanEnclosureAirFilter', width: wchChangeCleanEnclosureAirFilter },
        { header: 'CheckForRodentDamage', key: 'checkForRodentDamage', width: wchCheckForRodentDamage },
        { header: 'CheckLampsLed', key: 'checkLampsLed', width: wchCheckLampsLed },
        { header: 'ClearWeeds', key: 'clearWeeds', width: wchClearWeeds },
        { header: 'CheckRegroutPadConduit', key: 'checkRegroutPadConduit', width: wchCheckRegroutPadConduit },
        { header: 'GroundMountPadUndermining', key: 'groundMountPadUndermining', width: wchGroundMountPadUndermining },
        { header: 'EnclosureDamageVandalism', key: 'enclosureDamageVandalism', width: wchEnclosureDamageVandalism },
        { header: 'CleanUpGarbage', key: 'cleanUpGarbage', width: wchCleanUpGarbage },
        { header: 'TestOilPressureAlarm', key: 'testOilPressureAlarm', width: wchTestOilPressureAlarm },
        { header: 'TestHighTempAlarm', key: 'testHighTempAlarm', width: wchTestHighTempAlarm },
        { header: 'GeneratorDcBusFunction', key: 'generatorDcBusFunction', width: wchGeneratorDcBusFunction },
        { header: 'CheckForGasLeaks', key: 'checkForGasLeaks', width: wchCheckForGasLeaks },
        { header: 'TestCombustibleGasAlarm', key: 'testCombustibleGasAlarm', width: wchTestCombustibleGasAlarm },
        { header: 'TestTamperAlarm', key: 'testTamperAlarm', width: wchTestTamperAlarm },
        { header: 'TestWaterIntrusionAlarm', key: 'testWaterIntrusionAlarm', width: wchTestWaterIntrusionAlarm },
        { header: 'TestPadShearAlarm', key: 'testPadShearAlarm', width: wchTestPadShearAlarm }
      ]
    }
  }
}
